import { MultiSelectProps, MultiSelect, Loader, Avatar, Group, Text } from "@mantine/core";
import { useMemo } from "react";
import { getCurrentUser } from "@/services/auth";
import useGetActiveColaboradores from "../../hooks/useGetActiveColaboradores";
// prettier-ignore
const emptyArray: { value: string; label: string; image: TFileStored[] }[] = [];
const ColaboradorMultiSelector = (properties: MultiSelectProps) => {
  const uid = getCurrentUser()?.uid;
  const { data, isLoading, error } = useGetActiveColaboradores({
    select(dataSnapshot) {
      if (dataSnapshot.empty) {
        return [];
      }

      return dataSnapshot.docs
        .map((document_) => {
          const colaborador = document_.data();

          return {
            value: colaborador.refPath,
            label: colaborador.nome,
            image: colaborador.image
          };
        })
        .filter(
          (option): option is { value: string; label: string; image: TFileStored[] } => !!option.value && !!option.label
        );
    }
  });

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({ option }) => {
    const newData = data && data?.find((item) => item.value === option.value);
    return (
      <Group gap="sm">
        <Avatar
          src={newData && newData?.image && newData.image?.length > 0 ? newData?.image[0]?.path : ""}
          size={36}
          radius="xl"
        />
        <div>
          <Text size="sm">{option?.label}</Text>
        </div>
      </Group>
    );
  };
  const filteredData = useMemo(
    () => data?.filter((item) => item && item.value && item.label && item.value.split("/")[3] !== uid) || emptyArray,
    [data, uid]
  );

  return (
    <MultiSelect
      data={filteredData}
      renderOption={renderMultiSelectOption}
      leftSection={isLoading ? <Loader color="blue" size="1rem" /> : undefined}
      disabled={isLoading}
      error={error?.message}
      {...properties}
      value={Array.isArray(properties.value) ? properties.value?.filter(Boolean) : properties.value}
    />
  );
};

export default ColaboradorMultiSelector;
